import { Component } from '@angular/core'
import { SharedService } from '../../../../services/shared.service'
import {
  type NotificationPageDTO, MyMailboxService
} from '../../../../services/my-mailbox.service'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { type CustomerPortalConfig } from '@inside-hub-app/customer-portal-config'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { CustomerPortalSharedModule } from '@inside-hub-app/customer-portal-shared'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { NgxGlideModule } from 'ngx-glide'
import { GoogleMapsModule } from '@angular/google-maps'
import { A11yModule } from '@angular/cdk/a11y'
import { TextFieldModule } from '@angular/cdk/text-field'
@Component({
  selector: 'customer-portal-app-unread-mail',
  standalone: true,
  templateUrl: './unread-mail.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomerPortalSharedModule,
    HubChildTranslateModule,
    NgxSkeletonLoaderModule,
    NgxGlideModule,
    GoogleMapsModule,
    A11yModule,
    TextFieldModule
  ]
})
export class UnreadMailComponent {
  unread = 0

  hasMyMailbox

  sub = {
    onMessageCountLoaded: null
  }

  constructor (
    public sharedService: SharedService,
    private readonly myMailboxService: MyMailboxService,
    private readonly remoteConfigService: EfRemoteConfigurationService<CustomerPortalConfig>
  ) {
    this.hasMyMailbox = this.remoteConfigService.get('hasMyMailbox')

    this.sub.onMessageCountLoaded =
      this.myMailboxService.onMessageCountLoaded.subscribe(
        (myMailbox: NotificationPageDTO) => {
          if (myMailbox?.totalUnread != null) {
            this.unread = myMailbox.totalUnread
          }
        }
      )
  }
}
